import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./ExComAboutStyle.css";
import img1 from "../../Assets/About/Shahid Khan.jpeg";
import img2 from "../../Assets/About/Mirza Awal.png";
import img3 from "../../Assets/About/Shah Feroze.png";
import img4 from "../../Assets/About/Jobaida Feroze.png";
import img5 from "../../Assets/About/Rozina Khan.jpg";
import img6 from "../../Assets/About/Rehana Khan-1.png";
import img7 from "../../Assets/About/Tinni Chowdhury.png";
import img8 from "../../Assets/About/Shonda Murshid-2.png";
import Shikhaa_Logo from "../../Assets/Cover/Shikhaa_Logo.png";

const PrevArrow = ({ className, onClick }) => {
  return (
    <button className={`${className} custom-prev`} onClick={onClick}>
      ‹
    </button>
  );
};

const NextArrow = ({ className, onClick }) => {
  return (
    <button className={`${className} custom-next`} onClick={onClick}>
      ›
    </button>
  );
};

const ExecComAbout = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 800,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: true,

    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,

    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },

      {
        breakpoint: 850,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  // List of images and titles
  const images = [
    { src: img1, title: "M Shahid Khan: President" },
    { src: img2, title: "Mirza Abdul Awal: Vice President" },
    { src: img3, title: "Shah Feroze: General Secretary" },
    { src: img4, title: "Jobaida Feroze: Director of Finance" },
    { src: img5, title: "Rozina Khan: Director of Finance" },
    { src: img6, title: "Rehana Khan: Director of Public Relation" },
    { src: img7, title: "Tinni Chowdhury: Director of Events" },
    { src: img8, title: "Shanda Murshid: Director of Cultural Affairs" },
  ];

  return (
    <div className="execCom-About-container">
      <div className="Shikha_logo_Exec">
        <img src={Shikhaa_Logo} alt="Shikhaa Logo" />
      </div>

      <h1 id="exec-com-title">STARS IN SHIKHAA – THE LIGHT</h1>

      <Slider {...settings}>
        {images.map((image, index) => (
          <div key={index} className="carousel-item">
            <img src={image.src} alt={image.title} />

            <div className="image-title">{image.title}</div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default ExecComAbout;
